import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import controlInitAction from 'modules/controlInit/controlInit.action';
import { controlInitModule } from 'modules/controlInit/controlInit.reducer';
import { AppState } from 'store';
import { TOptionsQuery } from 'types/common';
import AdmControlInit from './AdmControlInit';

const AdmControlInitContainer = () => {
  const dispatch = useDispatch();
  const { currentGroup } = useSelector((state: AppState) => state.pages.groupsClass);
  const controlInitState = useSelector((state: AppState) => state.pages.controlInit);
  const getControlInit = (params: TOptionsQuery) => {
    dispatch(controlInitAction.getControlInit({ ...params, sortBy: 'id:desc' }));
  };

  const deleteControlInit = (data: { ctrRsId: number; groupId: number }) => {
    dispatch(controlInitAction.deleteControlInit(data));
  };

  const clearErr = () => {
    dispatch(controlInitModule.actions.setError(false));
  };

  const downloadControlInit = (data: { ctrRsId: number; groupId: number }) => {
    dispatch(controlInitAction.downloadControlInitFile(data));
  };
  return (
    <AdmControlInit
      getControlInit={getControlInit}
      currentGroup={currentGroup}
      controlInitState={controlInitState}
      deleteControlInit={deleteControlInit}
      clearErr={clearErr}
      downloadControlInit={downloadControlInit}
    />
  );
};

export default AdmControlInitContainer;
